if(!customElements.get('pro-deal-form')) {
  class proDealForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.guidelinesCategoriesInfo = JSON.parse(this.querySelector('[data-categories-info]').innerHTML)
      this.category = 0;
      this.categoryData = this.guidelinesCategoriesInfo[0];

      this.landingContainer = this.querySelector('[data-landing-content]');
      this.modalContainer = this.querySelector('[data-modal-container]');
      this.modalContent = this.querySelector('[data-modal-content]');
      this.confirmContainer = this.querySelector('[data-confirm-container]')

      this.guidelinesContent = this.querySelector('#guidelines-content');
      this.faqContent = this.querySelector('#faqs-content');
      this.formContent = this.querySelector('#prodeal-form-fields');
      this.formFiles = new DataTransfer();

      this.applyButton = this.querySelector('[data-apply-button]');
      this.guidelinesButton = this.querySelector('[data-guidelines-button]');
      this.faqButton = this.querySelector('[data-faq-button]');

      this.guidelinesOpenHandler = this.openGuidelinesModal.bind(this);
      this.guidelinesCategoryChangeHandler = this.updateGuidelinesCategory.bind(this);
      this.formCategoryChangeHandler = this.updateFormCategory.bind(this);
      this.faqOpenHandler = this.openFaqModal.bind(this);
      this.closeGuidelinesModalHandler = this.closeModal.bind(this);
      this.trapFocusHandler = this.trapFocusBlur.bind(this);
      this.applyClickHandler = this.openApplyform.bind(this);
      this.fileUpdateHandler = this.addFileToList.bind(this);
      this.formSubmitHandler = this.onFormSubmit.bind(this);
      this.phoneMaskingHandler = this.onPhoneKeyUp.bind(this);
      this.removeFileHandler = this.onRemoveFile.bind(this);
      this.validateFieldHandler = (evt) => {
        this.validateField(evt.target);
      }

      if(this.guidelinesButton) {
        this.guidelinesButton.addEventListener('click', this.guidelinesOpenHandler);
      }

      if(this.faqButton) {
        this.faqButton.addEventListener('click', this.faqOpenHandler);
      }

      if(this.applyButton) {
        this.applyButton.addEventListener('click', this.applyClickHandler);
      }
    }

    openGuidelinesModal() {
      const modalData = this.guidelinesContent.content.cloneNode(true);
      this.modalContent.replaceChildren(modalData);

      this.updateGuidelinesCategory()

      const categorySelect = this.modalContainer.querySelector('[data-category-select]');
      const closeModal = this.modalContainer.querySelector('[data-close-button]');
      categorySelect.addEventListener('change', this.guidelinesCategoryChangeHandler);
      closeModal.addEventListener('click', this.closeGuidelinesModalHandler, {once: true});
      this.openModal();
    }

    updateGuidelinesCategory(evt) {
      let selectedIndex = this.category;

      if(evt) {
        selectedIndex = evt.target.value;
        this.category = evt.target.value;
        this.categoryData = this.guidelinesCategoriesInfo[evt.target.value];
      }

      const currentCategory = this.guidelinesCategoriesInfo[selectedIndex];
      this.modalContainer.querySelector('[data-category-data]').innerHTML = currentCategory.content;

      this.updateCategoryDocuments(currentCategory);
    }

    updateFilesRequirement(currentCategory) {
      const fileInput = this.querySelector('input[type=file]');
      if(currentCategory.optionalDocuments) {
        fileInput.removeAttribute('required');
      } else {
        fileInput.setAttribute('required', true);
      }
    }

    updateCategoryDocuments(currentCategory) {
      const documentsList = this.modalContainer.querySelector('[data-category-documents]');
      const categorySelect = this.modalContainer.querySelector('[data-category-select]');

      documentsList.innerHTML = "";
      categorySelect.value = this.category;
      currentCategory.documents.forEach(doc => {
        const documentEl = document.createElement('li');
        documentEl.innerText = doc;

        documentsList.appendChild(documentEl);
      })
    }

    updateFormCategory(evt) {
      let selectedIndex = this.category;

      if(evt) {
        selectedIndex = evt.target.value;
        this.category = evt.target.value;
        this.categoryData = this.guidelinesCategoriesInfo[evt.target.value];
      }

      const currentCategory = this.guidelinesCategoriesInfo[selectedIndex];
      this.updateCategoryDocuments(currentCategory);
      this.updateFilesRequirement(currentCategory);
    }

    openModal(extraRounded) {
      toggleBodyLock(this.modalContainer, true);
      this.modalContainer.showModal();
      if(extraRounded) {
        this.modalContainer.classList.add('extra-rounded');
      }
      this.trapFocus();
    }

    closeModal() {
      toggleBodyLock(this.modalContainer, false);
      this.modalContainer.close();
      this.modalContainer.classList.remove('extra-rounded');
      this.referrer.focus();
    }

    openFaqModal() {
      const modalData = this.faqContent.content.cloneNode(true);
      this.modalContent.replaceChildren(modalData);

      this.openModal();

      const closeModal = this.modalContainer.querySelector('[data-close-button]');
      closeModal.addEventListener('click', this.closeGuidelinesModalHandler, {once: true});
    }

    openApplyform() {
      const modalData = this.formContent.content.cloneNode(true);
      this.modalContent.replaceChildren(modalData);
      this.filesContainer = this.modalContainer.querySelector('[data-files-container]');
      this.applicationForm = this.modalContainer.querySelector('[data-application-form]');

      const closeModal = this.modalContainer.querySelector('[data-close-button]');
      const categorySelect = this.modalContainer.querySelector('[data-category-select]');
      const fileField = this.modalContainer.querySelector('input[type="file"]');
      const phoneField = this.modalContainer.querySelector('input[type="tel"');
      const inputFields = this.modalContainer.querySelectorAll('input, textarea');

      closeModal.addEventListener("click", this.closeGuidelinesModalHandler, {
        once: true,
      });
      categorySelect.addEventListener("change", this.formCategoryChangeHandler);
      fileField.addEventListener('change', this.fileUpdateHandler);

      phoneField.addEventListener('keyup', this.phoneMaskingHandler);
      this.applicationForm.addEventListener('submit', this.formSubmitHandler);

      inputFields.forEach((input) => {
        input.addEventListener('keyup', this.validateFieldHandler);
        input.addEventListener('change', this.validateFieldHandler);
      });

      document.addEventListener('pro-deal:remove-file', this.removeFileHandler);

      this.updateFormCategory();
      this.phoneMaskingHandler({target: phoneField});
      this.openModal(true);
    }

    trapFocus() {
      this.referrer = document.activeElement;
      const focusableElements = this.modalContainer.querySelectorAll('a, button, input, select, textarea, summary, [tabindex]:not([tabindex="-1"])');
      this.focusableElements = Array.from(focusableElements).filter(el => {
        const rect = el.getBoundingClientRect();
        const style = window.getComputedStyle(el);
        return (
          rect.width > 0 &&
          rect.height > 0 &&
          style.visibility !== 'hidden' &&
          style.display !== 'none'
        );
      })

      this.firsFocusableElement = this.focusableElements[0];
      this.lastFocusableElement = this.focusableElements[this.focusableElements.length - 1];

      if(this.focusableElements.length > 0) {
        this.firsFocusableElement.focus();
        this.firsFocusableElement.addEventListener('keydown', this.trapFocusHandler);
        this.lastFocusableElement.addEventListener('keydown', this.trapFocusHandler);
      }
    }

    trapFocusBlur(evt) {
      if(evt.key == 'Tab') {
        if(evt.target == this.firsFocusableElement) {
          if (evt.shiftKey) {
            evt.preventDefault();
            this.lastFocusableElement.focus();
          }
        }

        if(evt.target == this.lastFocusableElement) {
          if(!evt.shiftKey) {
            evt.preventDefault();
            this.firsFocusableElement.focus();
          }
        }
      }
    }

    addFileToList(evt) {
      const inputField = evt.target;

      const filesList = Array.from(inputField.files);

      if(filesList.length > 0) {
        for(let file of filesList) {
          const fileEl = document.createElement('li');
          fileEl.setAttribute('data-file', file.name);
          fileEl.innerHTML = `<span>${file.name}</span>
          <button type="button" data-remove-file="${file.name}" onClick="this.dispatchEvent(new CustomEvent('pro-deal:remove-file', {bubbles: true}))">
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
              <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
            </svg>
            Remove
          </button>`

          this.filesContainer.appendChild(fileEl);
          this.formFiles.items.add(file);
        }

        inputField.files = this.formFiles.files;
      }
    }

    onRemoveFile(evt) {
      const button = evt.srcElement;
      const fileName = button.dataset.removeFile;
      const targetElement = this.modalContainer.querySelector(`[data-file="${button.dataset.removeFile}"]`);
      targetElement.remove();

      for(let i = 0; i < this.formFiles.items.length; i++) {
        if(fileName === this.formFiles.items[i].getAsFile().name) {
          this.formFiles.items.remove(i);
          continue;
        }
      }

      this.modalContainer.querySelector('input[type="file"]').files = this.formFiles.files;
    }

    validateFields(form) {
      let hasInvalid = false;
      let invalidCount = 0;
      const formFields = form.querySelectorAll('input, textarea');

      formFields.forEach((field) => {
        const isValid = this.validateField(field);

        if(!isValid) {
          invalidCount ++;
          hasInvalid = true;
        }

        if(!isValid && invalidCount == 1) {
          field.focus();
          field.scrollIntoView({
            behavior: "smooth",
            block: "center",
          })
        }
      })

      return hasInvalid;
    }

    validateField = (field) => {
      const isValid = field.checkValidity();

      if(!isValid) {
        field.classList.add('is-invalid');
      } else {
        field.classList.remove('is-invalid');
      }

      return isValid;
    }

    onFormSubmit(evt) {
      evt.preventDefault();
      const formData = new FormData(this.applicationForm);
      formData.set('category', this.categoryData.name);
      const hasInvalid = this.validateFields(evt.target);

      if(hasInvalid) {
        console.log('cannot submit, has invalid fields');
        return false;
      }

      fetch('https://hook.us1.make.com/ri8xi7xjf657rv4pnmt76w9i3t2fr1kc', {
        method: 'POST',
        body: formData,
      }).then(() => {
        this.openResultView({name: formData.get('firstname')});
      }).catch((error) => {
        console.error(error.message);
        console.error('form was not submitted there was an error');
      })
    }

    onPhoneKeyUp(evt) {
      const number = evt.target.value.replace(/(\D+)/g, '').match(/(\d{0,3})(\d{0,7})/);

      if(number[1]) {
        evt.target.value = number[2] ? `(${[number[1]]}) ${number[2]}`: `(${number[1]}`
      } else {
        evt.target.value = '';
      }
    }

    openResultView({
      name
    }) {
      this.landingContainer.classList.add('invisible');
      this.modalContainer.close();
      this.confirmContainer.showModal();

      const closeModal = this.confirmContainer.querySelector('[data-close-button]');

      if(closeModal) {
        closeModal.addEventListener('click', () => {
          this.confirmContainer.close();
        }, {once: true})
      }

      this.confirmContainer.querySelector('[data-applicant-name]').innerText = name;
    }
  }

  customElements.define('pro-deal-form', proDealForm)
}